import { TFunction } from 'i18next';

import dayjs from 'shared/helpers/dayjs';
import { Note, StackedNoteCardData, InstantReflex } from 'shiftNotes/_types';
import getNoteAuthorName from 'shiftNotes/helpers/getNoteAuthorName';
import getNoteTime from 'shiftNotes/helpers/getNoteTime';

function hasPendingMissingInfo(
  instantReflex: InstantReflex | undefined
): boolean {
  const step = instantReflex?.steps?.find(
    (s) => s.step_type === 'ask_for_details'
  );
  if (!step) return false;
  const hasQuestions = (step.questions?.length ?? 0) > 0;
  return hasQuestions && !step.completed_at;
}

export default function mapEventNoteToStackedCard(
  note: Note,
  t: TFunction
): StackedNoteCardData {
  const noteTime = dayjs(getNoteTime(note));
  const includeYear = noteTime.year() !== dayjs().year();
  const format = includeYear ? 'MMM D, YYYY, h:mm A' : 'MMM D, h:mm A';

  return {
    id: note.id,
    authorName: getNoteAuthorName(note, t),
    source: note.source,
    time: noteTime.format(format),
    body: note.edited_text,
    originalBody: note.edited_text_original,
    hasMissingInfo: hasPendingMissingInfo(note.instant_reflex),
    hasFile: Boolean(note.form_instance),
    formInstance: note.form_instance ?? undefined,
    attachments: note.attachments,
    instantReflex: note.instant_reflex,
    instantReflexes: note.instant_reflexes,
    userId: note.user?.id,
  };
}
